import Items from './Items'

module.exports = Items.reducer( null, 'MESSAGE_ROUTE', 'projectId', [ 'projectId' ] )
